import axios from 'axios';
import { useEffect, useState } from 'react'
import { getAccessToken, setDashboardCookies } from '../../services/authenticationService';

function SalesLensDashboard() {
  const [IFrameUrl,setIFrameUrl] = useState<string>("");
  useEffect(()=>{
    const displayDashboard = async ()=>{
      const token = getAccessToken() ?? "";
      const env = localStorage.getItem("env") ?? "prod";
      const resp = await axios.get("https://saleslens.salescode.ai/dashboard/session",{
        headers: {
          Authorization: token
        },
        params: {
          env,
        }
      })
      if(resp.status>=200 && resp.status<300){
        const salesLensUrl = resp?.data?.url;
        setIFrameUrl(salesLensUrl)
      if(window.location.hostname.includes("salescode.ai")){
        // await setDashboardCookies();
        // window.open("https://saleslens.salescode.ai/dashboard");
      }else{
        if(salesLensUrl){
          window.open(salesLensUrl)
        }
        window.history.back();
      }
    }
      // window.history.back();
      
    }
    displayDashboard() ;
  },[]);

  return <>
  <iframe src={IFrameUrl} title="SalesLens" height="100%" width="100%" style={{"border":"0px"}}></iframe>
  </>
}

export default SalesLensDashboard;